/**
 * @fileoverview 미납신고 목록 및 상세 조회 API 함수
 * 미납신고 목록과 개별 미납신고 상세 정보를 조회하고 검증하는 API 호출
 */

import { apiInstance } from "@core/api/axios/apiInstance";
import { getNonpaidReportsSchema, getNonpaidReportSchema, type badUserComplaintIDType, type GetNonpaidReportsType, type GetNonpaidReportType, type ReqNonpaidReportsType } from "@features/helpdesk/model/getNonpaidReportsModel";
import { parseSchema } from "@core/model/parseSchema";

/**
 * 미납신고 목록을 조회하는 API 함수
 *
 * @param {ReqNonpaidReportsType} params - 미납신고 목록 조회 파라미터
 * @returns {Promise<GetNonpaidReportsType | null>} 미납신고 목록 데이터 또는 null
 * @throws {Error} API 호출이 실패한 경우
 */
export const getNonpaidReports = async (params: ReqNonpaidReportsType): Promise<GetNonpaidReportsType | null> => {
  const res = await apiInstance.get(`nonpaidreport`, { params });
  return parseSchema<GetNonpaidReportsType>({
    schema: getNonpaidReportsSchema,
    rawData: res.data,
  });
};

/**
 * 미납신고 상세 정보를 조회하는 API 함수
 *
 * @param {Object} params - 미납신고 상세 조회 파라미터
 * @param {badUserComplaintIDType} params.badUserComplaintID - 조회할 미납신고의 ID
 * @returns {Promise<GetNonpaidReportType | null>} 미납신고 상세 데이터 또는 null
 * @throws {Error} API 호출이 실패한 경우
 */
export const getNonpaidReport = async (params: { badUserComplaintID: badUserComplaintIDType }): Promise<GetNonpaidReportType | null> => {
  const res = await apiInstance.get(`nonpaidreport/${params.badUserComplaintID}`);
  return parseSchema<GetNonpaidReportType>({
    schema: getNonpaidReportSchema,
    rawData: res.data,
  });
};
